import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShieldAlert, ArrowLeft, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { getLandingRouteForRole } from '../config/routePermissions';

export default function Forbidden403() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const attempted = location.state?.from || null;
  const landing = getLandingRouteForRole(user?.role);

  return (
    <div
      className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-10 bg-gradient-to-br from-slate-50 via-white to-slate-100 dark:from-slate-950 dark:via-slate-900 dark:to-slate-950"
      data-testid="forbidden-403-page"
    >
      <div className="max-w-md w-full bg-white dark:bg-slate-900 rounded-2xl shadow-xl border border-slate-200 dark:border-slate-800 overflow-hidden">
        <div className="bg-gradient-to-r from-rose-500 to-red-600 px-6 py-5 text-white flex items-center gap-3">
          <ShieldAlert className="h-8 w-8 flex-shrink-0" />
          <div>
            <h1 className="text-lg sm:text-xl font-bold leading-tight">403 · Akses Ditolak</h1>
            <p className="text-xs sm:text-sm text-rose-100/90">Halaman ini di luar cakupan role Anda</p>
          </div>
        </div>

        <div className="p-6 space-y-4">
          <p className="text-sm text-slate-600 dark:text-slate-300">
            Halo <strong className="text-slate-900 dark:text-slate-100">{user?.full_name || user?.username || 'Pengguna'}</strong>, akun Anda dengan role{' '}
            <span className="inline-flex items-center rounded-full bg-indigo-50 dark:bg-indigo-900/40 px-2 py-0.5 text-xs font-semibold text-indigo-700 dark:text-indigo-300">
              {(user?.role || 'unknown').replace(/_/g, ' ')}
            </span>{' '}
            tidak diberi akses ke halaman ini.
          </p>

          {attempted && (
            <div className="rounded-lg bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 px-3 py-2 text-xs text-slate-500 dark:text-slate-400">
              <span className="font-medium text-slate-600 dark:text-slate-300">URL yang diminta:</span>{' '}
              <code className="text-rose-600 dark:text-rose-400 break-all">{attempted}</code>
            </div>
          )}

          <p className="text-xs text-slate-500 dark:text-slate-400">
            Jika Anda merasa ini keliru, hubungi Administrator untuk penyesuaian role atau izin.
          </p>

          <div className="flex flex-col sm:flex-row gap-2 pt-2">
            <Link
              to={landing}
              data-testid="back-to-dashboard-btn"
              className="flex-1 inline-flex items-center justify-center gap-2 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium px-4 py-2 transition-colors"
            >
              <ArrowLeft className="h-4 w-4" />
              Kembali ke Beranda
            </Link>
            <button
              type="button"
              onClick={logout}
              data-testid="forbidden-logout-btn"
              className="flex-1 inline-flex items-center justify-center gap-2 rounded-lg border border-slate-300 dark:border-slate-700 text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 text-sm font-medium px-4 py-2 transition-colors"
            >
              <LogOut className="h-4 w-4" />
              Keluar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
